<template>
  <div class="NewsDetails">
    <banner title="新闻资讯"/>
    <div class="NewsDetails-product">
      <div class="nav-back" @click="goBack">< 返回上一页</div>
      <div class="NewsDetails-product-content">
        <h3 class="product-title">{{ newsInfo.informationTitle }}</h3>
        <div class="new-row">
          <p class="product-time mar20">来源：{{ newsInfo.releaseSource }}</p>
          <p class="product-time mar20">浏览量：{{ newsInfo.pageView }}</p>
          <p class="product-time">更新时间：{{ newsInfo.createTime }}</p>
        </div>
        <!-- 使用计算属性 processedHtml，不是直接 newsInfo.informationDesc -->
        <div class="product-content" v-html="processedHtml"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";

export default {
  name: "NewsDetails",
  components: {
    Banner
  },
  data() {
    return {
      newsInfo: {},
      formData: {}
    };
  },
  created() {
    this.formData.informationId = this.$route.params.id;
  },
  mounted() {
    this.loadData();
  },
  computed: {
    processedHtml() {
      const rawHtml = this.newsInfo.informationDesc || '';
      let html = rawHtml
          .replace(/\s+width="\d+"/gi, '')
          .replace(/\s+height="\d+"/gi, '');

      const imgReg = /<img[^>]*>/gi;
      html = html.replace(imgReg, (match) => {
        // 该图片不处理，保持原样
        if (match.includes('2879f418-b824-482f-9eea-6b9b6842a2b1.png')) {
          return match;
        }
        // 其他图片：自适应 + 水平居中
        return match.replace(/^<img/, '<img style="max-width:100%;height:auto;display:block;margin:8px auto;"');
      });

      return html;
    }
  },
  methods: {
    loadData() {
      this.$http
          .post(`https://www.tgr39.com/mall-base/baseInformationInfo/queryInformationInfo`, this.formData)
          .then(response => {
            this.newsInfo = response.data.data;
          })
          .catch(error => {
            console.log(error);
          });
    },
    goBack() {
      window.history.back();
    }
  }
};
</script>

<style lang="scss" scoped>
.NewsDetails {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;

  &-product {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;

    &-content {
      width: 900px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 30px 0;

      .product-title {
        font-size: 26px;
        color: #333333;
        padding: 20px 0 10px;
        width: 100%;
        text-align: center;
      }

      .mar20 {
        margin-right: 20px;
      }

      .new-row {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;
      }

      .product-content {
        width: 100%;
        font-size: 16px;
        line-height: 1.5;
        padding: 20px 0;

        > p {
          margin-bottom: 10px;
        }
      }
    }
  }
}

.nav-back {
  padding: 20px;
  cursor: pointer;
  font-size: 16px;
  color: #333333;

  &:hover {
    color: #48a83c;
  }
}

@media screen and (max-width: 768px) {
  .NewsDetails {
    &-product {
      width: 100%;

      &-content {
        width: 100%;
        padding: 16px;
        box-sizing: border-box;

        .product-title {
          font-size: 20px;
          padding: 12px 0 8px;
        }

        .new-row {
          flex-wrap: wrap;
          justify-content: flex-start;
          margin-bottom: 16px;

          .mar20 {
            margin-right: 12px;
          }

          .product-time {
            font-size: 13px;
            color: #666;
          }
        }

        .product-content {
          padding: 10px 0;
          font-size: 15px;
          line-height: 1.6;
        }
      }
    }
  }
  .nav-back {
    padding: 14px 16px;
    font-size: 15px;
  }
}
</style>